export default "__VITE_ASSET__CMMMeJzp__"